import { Dispatch, SetStateAction, useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

export interface StateContextValue<T> {
  state: T;
  setState: Dispatch<SetStateAction<T>>;
}

export function createStateContext<T>(
  name: string = 'StateContext',
  initialValue: StateContextValue<T> | null = null,
) {
  const StateContext = createNamedContext<StateContextValue<T> | null>(name, initialValue);

  const useStateContext = () => {
    const value = useContext(StateContext);

    if (value === null) {
      throw new Error('useStateContext hooks should be used in a context of StateContext');
    }

    return [value.state, value.setState] as [T, Dispatch<SetStateAction<T>>];
  };

  return {
    StateContext,
    useStateContext,
  };
}

const { StateContext: TradeContext, useStateContext: useTradeContext } =
  createStateContext<Conversation.Trade.TradeWithLogistics>('TradeContext', null);

export { TradeContext, useTradeContext };
